import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

import MpesaCard from "examples/Cards/PaymentMethodCards/MpesaCard";
import CreditCard from "examples/Cards/PaymentMethodCards/CreditCard";
import BankTransferCard from "examples/Cards/PaymentMethodCards/BankTransferCard";
import ChequeCard from "examples/Cards/PaymentMethodCards/ChequeCard";
import MasterCard from "examples/Cards/MasterCard";

// Routes
import { routes } from "routes";
import footerRoutes from "footer.routes";

// Images
import mpesaImage from "assets/images/logos/m-pesa.png";
import creditImage from "assets/images/logos/bidii-credit.png";
import bankTransferImage from "assets/images/logos/bank-transfer.png";
import chequeImage from "assets/images/logos/cheque.png";

import { getSearchPolicy } from "actions/policyActions";
import { getPaymentInfo } from "actions/infoActions";

import { comprehensive } from "pages/Motor/components/data";
import { getOrderSingle } from "actions/orderActions";
import MKAvatar from "components/MKAvatar";
import { Divider } from "@mui/material";

function Checkout() {
  const dispatch = useDispatch();
  const { id } = useParams();
  console.log("🚀 ~ file: index.js:41 ~ Checkout ~ id:", id);
  const [currentInfo, setCurrentInfo] = useState(null);

  const paymentInfo = useSelector((state) => state.paymentInfo);
  const { info } = paymentInfo;
  console.log("🚀 ~ file: index.js:55 ~ Checkout ~ info:", info);

  // const location = useLocation();
  // const category = location.state;
  // const [inputs, setInputs] = useState({
  //   policyNumber: "",
  //   policyName: "",
  //   category: category,
  //   amount: "",
  //   insuredItems: "",
  // });
  const [activeTab, setActiveTab] = useState(0);
  const [active, setActive] = useState("computedAmoun:-");

  const handleTabType = (event, newValue) => setActiveTab(newValue);

  const orderSingle = useSelector((state) => state.orderSingle);
  const { singleOrder } = orderSingle;

  useEffect(() => {
    dispatch(getOrderSingle(id));
  }, [dispatch, singleOrder?.length, id]);

  useEffect(() => {
    // if (info) {
    dispatch(getPaymentInfo());
    // }
  }, [dispatch]);

  useEffect(() => {
    if (info?.length) {
      setCurrentInfo(info[0]);
    }
  }, [info?.length]);

  const handleCurrentInfo = (item) => {
    info?.map((val) => {
      if (val.method === item) {
        setCurrentInfo(val);
      }
    });
  };

  // const handleFilter = (e) => {
  //   e.preventDefault();
  //   dispatch(getSearchPolicy(inputs));
  // };

  // const handleClearFilters = (e) => {
  //   e.preventDefault();
  //   setInputs({
  //     policyNumber: "",
  //     policyName: "",
  //     category: category,
  //     amount: "",
  //     insuredItems: "",
  //   });
  //   dispatch(
  //     getSearchPolicy({
  //       policyNumber: "",
  //       policyName: "",
  //       category: category,
  //       amount: "",
  //       insuredItems: "",
  //     })
  //   );
  // };

  // const changeHandler = (e) => {
  //   setInputs({
  //     ...inputs,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  return (
    <>
      <DefaultNavbar
        action={{
          type: "external",
          route: "#",
          label: "Call Us",
          color: "default",
        }}
      />
      <Container sx={{ paddingTop: 25 }}>
        <Grid container item justifyContent="center" xs={12} lg={8} mx="auto">
          <AppBar position="static">
            <Tabs value={activeTab} onChange={handleTabType}>
              <Tab label="MPESA" onClick={() => handleCurrentInfo("MPESA")} />
              <Tab
                label="Credit"
                onClick={() => handleCurrentInfo("FINANCING")}
              />
              <Tab
                label="Bank Transfer"
                onClick={() => handleCurrentInfo("BANK TRANSFER")}
              />
              <Tab
                label="Bank Cheque"
                onClick={() => handleCurrentInfo("CHEQUE")}
              />
            </Tabs>
          </AppBar>
        </Grid>
      </Container>

      <Container>
        <MKBox component="section" my={5}>
          {/* <Container> */}
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MKBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
              >
                <MKBox py={6} pr={6} my="auto">
                  <MKTypography variant="h3" color="dark" mb={1}>
                    Secure Checkout
                  </MKTypography>
                  <MKTypography
                    variant="body2"
                    color="dark"
                    opacity={0.8}
                    mb={3}
                  >
                    Select your preferred payment method from the tabs above.
                  </MKTypography>
                </MKBox>
              </MKBox>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MKBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
              >
                <MasterCard currentInfo={currentInfo} />
              </MKBox>
            </Grid>
          </Grid>
        </MKBox>
      </Container>

      <Container>
        <MKBox component="section">
          {/* <Container> */}
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              {/* <Grid container justifyContent="flex-start"> */}
              <MKBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
              >
                <MKBox py={6} pr={6} my="auto">
                  {/* <MKTypography variant="h3" color="dark" mb={1}>
                    Secure Checkout
                  </MKTypography>
                  <MKTypography
                    variant="body2"
                    color="dark"
                    opacity={0.8}
                    mb={10}
                  >
                    Select your preferred payment method from the tabs above.
                  </MKTypography> */}
                  <MKBox display="flex" py={3}>
                    <MKBox maxWidth={300}>
                      <MKAvatar
                        src={singleOrder?.company?.companyLogo}
                        name={singleOrder?.company?.companyName}
                        size="md"
                      />
                    </MKBox>
                    <MKBox display="flex" flexDirection="column">
                      <MKTypography
                        component="span"
                        variant="button"
                        color="dark"
                        opacity={0.8}
                        ml={2}
                        fontWeight="bold"
                        fontSize="medium"
                      >
                        {singleOrder?.company?.companyName}
                      </MKTypography>
                      <MKTypography
                        component="span"
                        variant="button"
                        color="dark"
                        opacity={0.8}
                        ml={2}
                        fontWeight="regular"
                      >
                        {singleOrder?.category?.mainCategory},{" "}
                        {singleOrder?.category?.category}
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                  <MKBox display="flex" color="dark" p={1}>
                    <MKTypography variant="button" color="dark">
                      {/* <i className="fas fa-map-marker-alt" /> */}
                      Order Number:
                    </MKTypography>
                    <MKTypography
                      component="span"
                      variant="button"
                      color="dark"
                      opacity={0.8}
                      ml={2}
                      fontWeight="bold"
                      fontSize="medium"
                    >
                      {singleOrder?._id}
                    </MKTypography>
                  </MKBox>
                  <MKBox display="flex" color="dark" p={1}>
                    <MKTypography variant="button" color="dark">
                      {/* <i className="fas fa-map-marker-alt" /> */}
                      Policy Name:
                    </MKTypography>
                    <MKTypography
                      component="span"
                      variant="button"
                      color="dark"
                      opacity={0.8}
                      ml={2}
                      fontWeight="bold"
                      fontSize="medium"
                    >
                      {singleOrder?.policy?.policyName}
                    </MKTypography>
                  </MKBox>
                  <MKBox display="flex" color="dark" p={1}>
                    <MKTypography variant="button" color="dark">
                      {/* <i className="fas fa-map-marker-alt" /> */}
                      Policy Number:
                    </MKTypography>
                    <MKTypography
                      component="span"
                      variant="button"
                      color="dark"
                      opacity={0.8}
                      ml={2}
                      fontWeight="bold"
                      fontSize="medium"
                    >
                      {singleOrder?.policy?.policyNumber}
                    </MKTypography>
                  </MKBox>
                  <MKBox display="flex" color="dark" p={1}>
                    <MKTypography variant="button" color="dark">
                      {/* <i className="fas fa-map-marker-alt" /> */}
                      Basic Policy Amount:
                    </MKTypography>
                    <MKTypography
                      component="span"
                      variant="button"
                      color="dark"
                      opacity={0.8}
                      ml={2}
                      fontWeight="bold"
                      fontSize="medium"
                    >
                      {"Ksh. "} {singleOrder?.policy?.premiumAmount}
                    </MKTypography>
                  </MKBox>
                  <MKBox display="flex" color="dark" p={1}>
                    <MKTypography variant="button" color="dark">
                      {/* <i className="fas fa-map-marker-alt" /> */}
                      Policy Addons:
                    </MKTypography>
                    <MKBox display="flex" flexDirection="column">
                      {singleOrder?.addons?.map((item) => (
                        <MKTypography
                          component="span"
                          variant="button"
                          color="dark"
                          opacity={0.8}
                          ml={2}
                          fontWeight="bold"
                          fontSize="medium"
                        >
                          {item?.addonName} {" - Ksh. "} {item?.addonAmount}
                        </MKTypography>
                      ))}
                    </MKBox>
                  </MKBox>
                  <MKBox display="flex" color="dark" p={1}>
                    <MKTypography variant="button" color="dark">
                      {/* <i className="fas fa-map-marker-alt" /> */}
                      Status:
                    </MKTypography>
                    <MKTypography
                      component="span"
                      variant="button"
                      color="dark"
                      opacity={0.8}
                      ml={2}
                      fontWeight="bold"
                      fontSize="medium"
                    >
                      {singleOrder?.status}
                    </MKTypography>
                  </MKBox>
                  <Divider />
                  <MKBox display="flex" color="dark" p={1}>
                    <MKTypography variant="button" color="dark">
                      {/* <i className="fas fa-envelope" /> */}
                      Total Amount:
                    </MKTypography>
                    <MKTypography
                      component="span"
                      variant="button"
                      color="dark"
                      opacity={0.8}
                      ml={2}
                      fontWeight="bold"
                      fontSize="medium"
                    >
                      Ksh. {singleOrder?.computedAmount}
                    </MKTypography>
                  </MKBox>
                </MKBox>
              </MKBox>
              {/* </Grid> */}
            </Grid>

            <Grid
              item
              xs={12}
              lg={6}
              md={6}
              sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}
            >
              {activeTab === 0 ? (
                <MpesaCard
                  image={mpesaImage}
                  title="Mpesa Payment"
                  amountToPay={singleOrder?.computedAmount}
                  orderId={singleOrder?._id}
                  client={singleOrder?.requestedBy}
                  action={{
                    type: "external",
                    route:
                      comprehensive.information.cardInformation.actionRoute,
                    color: "info",
                    label: "INITIATE PAYMENT",
                  }}
                />
              ) : activeTab === 1 ? (
                <CreditCard
                  image={creditImage}
                  title="Receive Financing from Bidii Credit"
                  amountToPay={singleOrder?.computedAmount}
                  orderId={singleOrder?._id}
                  client={singleOrder?.requestedBy}
                  action={{
                    type: "external",
                    route:
                      comprehensive.information.cardInformation.actionRoute,
                    color: "info",
                    label: "INITIATE FINANCING",
                  }}
                />
              ) : activeTab === 2 ? (
                <BankTransferCard
                  image={bankTransferImage}
                  title="Bank Transfer Payment"
                  amountToPay={singleOrder?.computedAmount}
                  orderId={singleOrder?._id}
                  client={singleOrder?.requestedBy}
                  action={{
                    type: "external",
                    route:
                      comprehensive.information.cardInformation.actionRoute,
                    color: "info",
                    label: "INITIATE REQUEST",
                  }}
                />
              ) : activeTab === 3 ? (
                <ChequeCard
                  image={chequeImage}
                  title="Cheque Payment"
                  amountToPay={singleOrder?.computedAmount}
                  orderId={singleOrder?._id}
                  client={singleOrder?.requestedBy}
                  action={{
                    type: "external",
                    route:
                      comprehensive.information.cardInformation.actionRoute,
                    color: "info",
                    label: "INITIATE PROCESSING",
                  }}
                />
              ) : (
                <MKTypography
                  display="inline"
                  variant="h5"
                  textTransform="capitalize"
                  fontWeight="regular"
                >
                  Select a payment method tab from above list
                </MKTypography>
              )}
            </Grid>
          </Grid>
          {/* </Container> */}
        </MKBox>
      </Container>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Checkout;
